export const TABLE_MODES = {
    FUTURE: 'future',
    PAST: 'past',
}
